import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import * as _ from "lodash";

@Injectable()
export class AuthService {
  domain = environment.domain; //set Domain
  authToken;
  user;
  role = "";
  sub_role = "";

  roles = {
    'グロービス事務局':'admin',
    'お客様事務局':'customer',
    '受講生向け':'student',
    'コースフォーマット・エディター':'courseformat_editor',
    'オペレーター':'operator',
  };
  rolesAdmin = {
    'グロービス事務局':'admin',
    'お客様事務局':'customer',
    'コースフォーマット・エディター':'courseformat_editor',
    'オペレーター':'operator',
    };

  nowToken = this.getToken();

   //option for format send data
  options = new RequestOptions({
    headers: new Headers({
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'x-access-token': this.nowToken//this.getToken()
    })
  });

  options_file_download = new RequestOptions({
    headers: new Headers({
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'x-access-token': this.nowToken
    }),
    responseType: ResponseContentType.Blob
  });

  constructor(
  	private http: Http
  ) {
    this.user = JSON.parse(localStorage.getItem('user'));
  }

  //---------------------------------- Getting API data with subscribe ---------------------------------------------------

  refresh_nowToken_on_options_file_download(){
    this.nowToken = this.getToken();
    this.options_file_download = new RequestOptions({
      headers: new Headers({
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'x-access-token': this.nowToken
      }),
      responseType: ResponseContentType.Blob
    });
  }

  //Getting Login API  
  loginApi(UserValue){
    return this.http.post(this.domain + 'user/login', UserValue , this.options).map(res => res.json());    
  }

  //Student Login API
  studentLoginApi(StudentValue) {
    return this.http.post(this.domain + 'student/login', StudentValue, this.options).map(res => res.json());
  }

  //Getting Login Role 
  getRoleLogin(){
    var userValue = localStorage.getItem('user');
    var userParse =  JSON.parse(userValue);
    
    return this.http.get(this.domain + 'role/' +  userParse['role_id'] ,this.options).map(res => res.json());
  }

  apiSendMail(type, body) {
    const url = this.domain + type + '/mail_reset';

    return this.http.post(url, body, this.options).map(res => res.json());
  }

  apiCheckResetPassword(type, userId) {
    const url = this.domain + type + '/reset_password/' + userId;

    return this.http.get(url, this.options).map(res => res.json());
  }

  apiPostResetPassword(type, body,  userId) {
    const url = this.domain + type + '/reset_password/' + userId;

    return this.http.post(url, body, this.options).map(res=> res.json());
  }

  apiGetResetUserData(type , resetID){
    const url = this.domain  + type + '/reset_password/' + resetID;

    return this.http.get(url, this.options).map(res => res.json());
  }

  apiGetTokenByUser(type, username){
    const url = this.domain  + type + '/reset_password/web_token/' + username;

    return this.http.get(url, this.options).map(res => res.json());    
  }
  // ---------------------------------- Process subcribe API data --------------------------------------------------------

  //Process Login API data with call back 
  loginProcess(UserValue , callBack) {
    if (UserValue.type === "student") {
      UserValue = _.omit(UserValue, ['type']);
      this.studentLoginApi(UserValue).subscribe( data => {
        this.loginSuccess(data, callBack);
      }, err => {
        this.loginErr(err, callBack);
      });
    } else {
      this.loginApi(UserValue).subscribe( data => {
        this.loginSuccess(data, callBack);
      }, err => {
        this.loginErr(err, callBack);
      });
    }
  }

  loginSuccess(data, callBack) {
    var returnValue = {
      errorMessage : '',
      messageData : '',
      success : true,
    };

    if(!data.success) {
      returnValue.errorMessage = 'alert alert-danger';
      returnValue.messageData = data.msg;
      returnValue.success = false;

      return callBack(returnValue);
    }

    if (data.role_id) {
      // this is student
      this.storeUserData(data.token, data.student, data.role_id);
    } else {
      this.storeUserData(data.token, data.user);
    }

    callBack(returnValue);
  }

  loginErr(err, callBack) {
    var returnValue = {
      errorMessage : 'alert alert-danger',
      messageData : "ユーザーIDまたはパスワードが間違っています。",
      success : false,
    };

    callBack(returnValue);
  }

  sendMailPassword(data, callBack) {
    var returnValue = {
      errorMessage : '',
      messageData : '',
      success : true,
    };

    if (data.type === 'student') {
      data = _.omit(data, ['type']);
      this.apiGetTokenByUser('student' , data.loginid).subscribe( result => {
        data['token'] = result.token;
        this.apiSendMail('student', data).subscribe(response => {
          this.sendMailSuccess(returnValue, callBack);
        }, err => this.sendMailErr(err, returnValue, callBack, 'student'));  
      });
    } else {
      this.apiGetTokenByUser('user' , data.email).subscribe( result => {
          data['token'] = result.token;
          this.apiSendMail('user', data).subscribe(response => {
          this.sendMailSuccess(returnValue, callBack);
        }, err => this.sendMailErr(err, returnValue, callBack, 'notStudent'));
      });
    }
  }

  sendMailSuccess(retVal, callBack) {
    retVal.errorMessage = 'alert alert-success';
    retVal.messageData = 'パスワードをリセットするためのリンクをメール送信しました。';

    callBack(retVal);
  }

  sendMailErr(err, retVal, callBack, type) {
    retVal.errorMessage = 'alert alert-danger';
    retVal.messageData = "メールアドレスが登録されていません。";
    if (type == 'student') {
      retVal.messageData = 'ユーザーIDが登録されていません。';
    }
    retVal.success = false;
    
    callBack(retVal);
  }

  checkingResetPassword(type, userId) {
    return new Promise<any>((resolve, reject) => {
      if (type == 'student') {
        this.apiCheckResetPassword(type, userId).subscribe(response => {
          resolve(response);
        }, err => reject(err));
      }
      else {
        this.apiCheckResetPassword(type, userId).subscribe(response => {
          resolve(response);
        }, err => reject(err));
      }
    });
  }

  postResetPassword(type, data, userId, callBack) {
    var returnValue = {
      errorMessage : '',
      messageData : '',
      success : true,
    };

    if (type == 'student') {      
        this.apiPostResetPassword(type, data, userId).subscribe(response => {
          this.successPostResetPassword(returnValue, callBack);
        }, err => this.errPostResetPassword(err, returnValue, callBack));
    } else {
        this.apiPostResetPassword(type, data, userId).subscribe(response => {
          this.successPostResetPassword(returnValue, callBack);
        }, err => this.errPostResetPassword(err, returnValue, callBack));
    }
  }

  successPostResetPassword(retVal, callBack) {
    retVal.errorMessage = 'alert alert-success';
    retVal.messageData = 'パスワードは正常に更新されました。';

    callBack(retVal);
  }

  errPostResetPassword(err, retVal, callBack) {
    retVal.errorMessage = 'alert alert-danger';
    retVal.messageData = "パスワードを更新できませんでした。";
    retVal.success = false;

    callBack(retVal);
  }


  //store local user data
  storeUserData(token, user, role = "") {
    localStorage.setItem('token', token);
    this.authToken = token;
    this.storeUserByRole(user, role);
    var today = new Date();

    today.setHours(today.getHours()+2);
    
    // set time out +6
    const TimeOut = {
      TimeOut: today
    }
    this.updateToken(token); 
    localStorage.setItem('globis_time',  JSON.stringify(TimeOut));

    this.getRoleLogin().subscribe(data => {
      let role = this.roles[data.name];
      if (role) {
        
        role = this.fRole(role);

        this.role = role;
        localStorage.setItem('role', role);
      }
    });
  }

  fRole(real_role){
    //すこしずるします(adminと同じ権限だけど表示を少し変えたい場合に、roleをadminにしてsub_roleに本来のを入れてsubで判別)
    if(real_role=='operator'){
      real_role = 'admin';
      this.sub_role = 'operator';
      localStorage.setItem('sub_role', this.sub_role);
    }
    return real_role;
  }

  storeUserByRole(user, role) {
    if (role) {
      const assignedUser = Object.assign({role_id: role}, user);
      this.user = assignedUser;

      return localStorage.setItem('user', JSON.stringify(assignedUser));
    }
    this.user = user;

    return localStorage.setItem('user', JSON.stringify(user));
  }

  checkLoginRole(AcountRole, callBack){
    this.getRoleLogin().subscribe( data => {
      if(data.name == AcountRole){
        callBack(true);
      }else{
        callBack(false);
      }
    })
  }

  authRedirect(router, screen){
    let navigate = 'login';
    if (screen == 'student') navigate = 'student/login';

    if (this.checkTimeOut()) {

      this.getRoleLogin().subscribe(data => {
        let role = this.roles[data.name];

        if (role) {
          
          role = this.fRole(role);
          
          this.role = role;
          localStorage.setItem('role', role);

          if (screen != this.role) {
            if(this.role == "courseformat_editor"){
              router.navigateByUrl(this.role + '/format');
            }else{
              router.navigateByUrl(this.role + '/dashboard');
            }
          }
          else{
            return true;
          }
          
        }
        else {
          router.navigateByUrl(navigate);
        }
      });
    } else {
      router.navigateByUrl(navigate);
    }
    
    
  }
  
  //update Token
  updateToken(token){
     //option for format send data
  this.options = new RequestOptions({
    headers: new Headers({
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'x-access-token': token
    })
  });
  }
  //checking the login still valid or not
  checkTimeOut(){    
    const checkTime = JSON.parse(localStorage.getItem('globis_time'));
    const user = JSON.parse(localStorage.getItem('user'));

     if (checkTime == null || user == null){
       return false;
     }else{
       var checkTimeout = new Date(checkTime.TimeOut);
       var dateNow = new Date();

       if(checkTimeout >= dateNow){
         return true;
       }else{
         localStorage.removeItem('globis_time');
         localStorage.removeItem('token');
         localStorage.removeItem('user');
         localStorage.removeItem('role');
         localStorage.removeItem('sub_role');
         return false;
       }
     }
  }

  validateAuth(){
    this.user = localStorage.getItem('user');
    if(this.user){
      return true;
    }else{
      return false;
    }
  }
  
  deleteAuth(){
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('role');
    localStorage.removeItem('sub_role');
    localStorage.removeItem('global_time');
    localStorage.removeItem('search');
    localStorage.removeItem('backBtn');
    localStorage.removeItem('tmpSearch');
    this.user = localStorage.getItem('user');
    this.role = localStorage.getItem('role');
    this.sub_role = localStorage.getItem('sub_role');
    if(this.user){
      return true;
    }else{
      return false;
    }
  }

  middlewareDeleteAuth() {
    return new Promise<any>((resolve, reject) => {
      resolve(this.deleteAuth());
    });
  }
 
  //get token data
  getToken(){
    var token;
    token = localStorage.getItem('token');

    return token;
  }

  checkRole(){
    if(!this.role){
      this.role = localStorage.getItem('role');
      this.sub_role = localStorage.getItem('sub_role');
    }

    return this.role;
  }
  checkSubRole(){
    if(!this.sub_role){
      this.sub_role = localStorage.getItem('sub_role');
    }

    return this.sub_role;
  }
  
  getRouteByRole() {
    return this.role;
  }
  
  //getName For user
  getName(){
    return new Promise<any>((resolve, reject) => {
      resolve(localStorage.getItem('user'));
    });
 }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts